import _ from 'lodash';
import services from 'services/services';

// Import types
import type { AgreementsType, SubscriberAgreementsType } from 'types/api/agreements';

export const fetchAgreementsByType = async (type: string): Promise<AgreementsType> => {
	try {
		const response = await services.get<AgreementsType>(`/agreements/${type}`);
		return response.data;
	} catch {
		return [];
	}
};

export const fetchSubscriberAgreements = () => services.get<SubscriberAgreementsType>('/subscriber/agreements').then((response) => response.data);

export const fetchAgreements = (agreements: string[]) =>
	Promise.all(agreements.map(fetchAgreementsByType))
		.then(_.flatten)
		.then((data) => _.sortBy(data, 'rank'));
